export default __webpack_public_path__ + "static/fan_w.e797edcfc9e8e7e0a53d3b15aea17696.svg";